import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { AdminProvider } from "@/contexts/AdminContext";
import { SettingsProvider } from "@/contexts/SettingsContext";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import ThemeApplier from "@/components/ThemeApplier";
import VisitTracker from "@/components/VisitTracker";
import LeadCapturePopup from "@/components/LeadCapturePopup";

import Home from "@/pages/Home";
import ProjectPage from "@/pages/ProjectPage";
import SavedPage from "@/pages/SavedPage";
import ContactPage from "@/pages/ContactPage";
import ConsultationPage from "@/pages/ConsultationPage";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProjects from "@/pages/admin/AdminProjects";
import AdminProjectForm from "@/pages/admin/AdminProjectForm";
import AdminComments from "@/pages/admin/AdminComments";
import AdminInquiries from "@/pages/admin/AdminInquiries";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminCleanup from "@/pages/admin/AdminCleanup";

function PageShell({ children }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  const isConsultation = location.pathname.startsWith("/consultation");
  return <main className={isAdmin || isConsultation ? "" : "min-h-screen"}>{children}</main>;
}

function ChromeOutsideRoutes() {
  const location = useLocation();
  const isConsultation = location.pathname.startsWith("/consultation");
  // Hide the site-wide Footer + FloatingWhatsApp on the consultation page
  // so the embedded chat iframe occupies the full viewport below the
  // slim back-to-home header.
  if (isConsultation) return null;
  return (
    <>
      <Footer />
      <FloatingWhatsApp />
      <LeadCapturePopup />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SettingsProvider>
          <AuthProvider>
            <AdminProvider>
              <ThemeApplier />
              <VisitTracker />
              <Toaster position="bottom-center" richColors theme="dark" />
              <PageShell>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/saved" element={<SavedPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/consultation" element={<ConsultationPage />} />
                  <Route path="/project/:slug" element={<ProjectPage />} />

                  {/* Admin */}
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route path="/admin" element={<AdminLayout />}>
                    <Route index element={<AdminDashboard />} />
                    <Route path="dashboard" element={<AdminDashboard />} />
                    <Route path="projects" element={<AdminProjects />} />
                    <Route path="projects/new" element={<AdminProjectForm />} />
                    <Route path="projects/edit/:id" element={<AdminProjectForm />} />
                    <Route path="comments" element={<AdminComments />} />
                    <Route path="inquiries" element={<AdminInquiries />} />
                    <Route path="categories" element={<AdminCategories />} />
                    <Route path="settings" element={<AdminSettings />} />
                    <Route path="cleanup" element={<AdminCleanup />} />
                  </Route>
                </Routes>
              </PageShell>
              <ChromeOutsideRoutes />
            </AdminProvider>
          </AuthProvider>
        </SettingsProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
